module.exports = __webpack_public_path__ + "static/img/FANGZHENGSHUSONGFANTI-1_0.272fd8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/suft/FANGZHENGSHUSONGFANTI-1_0.svg
// module id = Bzzv
// module chunks = 2